import React, {useEffect} from 'react';
import {BrowserRouter, Navigate, Route, Routes, useLocation, useNavigationType, useParams} from 'react-router-dom';
import Footer from './components/footer/Footer';
import WordPressPage from './components/wordpress/WordPressPage';
import {ConfigProvider} from './data/ConfigContext';
import ArticleView from './pages/article/ArticleView';
import Home from './pages/home/Home';
import Login from './pages/login/Login';
import Navbar from './pages/navbar/Navbar';
import News from './pages/news/News';
import NotFound from './pages/notfound/NotFound';
import Schedule from './pages/schedule/Schedule';
import {STATIC_PAGES} from './pages/staticPages';
import Teams from './pages/teams/Teams';

/** Opens new pages at the top; back/forward keeps the browser's scroll restoration. */
const ScrollToTop = () => {
    const {pathname} = useLocation();
    const navigationType = useNavigationType();

    useEffect(() => {
        if (navigationType !== 'POP') {
            window.scrollTo({top: 0, behavior: 'instant' as ScrollBehavior});
        }
    }, [pathname, navigationType]);

    return null;
};

/** Article links of the previous site version ("/articleView/1179"); the server redirects them as well. */
const LegacyArticleRedirect = () => {
    const {id = ''} = useParams();
    return <Navigate to={`/news/${id}`} replace/>;
};

const App = () => (
    <BrowserRouter>
        <ConfigProvider>
            <ScrollToTop/>
            <Navbar/>
            <main>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/news" element={<News/>}/>
                    <Route path="/news/:slug" element={<ArticleView/>}/>
                    <Route path="/termine" element={<Schedule/>}/>
                    <Route path="/teams/:slug" element={<Teams/>}/>
                    <Route path="/login" element={<Login/>}/>
                    {STATIC_PAGES.map(page => (
                        <Route key={page.path} path={page.path} element={
                            <WordPressPage key={page.postId} postId={page.postId} title={page.title} description={page.description}/>
                        }/>
                    ))}
                    <Route path="/schedule" element={<Navigate to="/termine" replace/>}/>
                    <Route path="/articleView/:id" element={<LegacyArticleRedirect/>}/>
                    <Route path="/home" element={<Navigate to="/" replace/>}/>
                    <Route path="/club" element={<Navigate to="/geschichte" replace/>}/>
                    <Route path="*" element={<NotFound/>}/>
                </Routes>
            </main>
            <Footer/>
        </ConfigProvider>
    </BrowserRouter>
);

export default App;
